import React, { ReactNode } from 'react';
import classNames from 'classnames';

import { Checkbox } from '../Checkbox';

import styles from './AutoCompleteOption.module.css';

interface Props {
  label: string | ReactNode;
  setRef?: (el: HTMLDivElement | null) => void;
  selected: boolean;
  highlighted: boolean;
  dataHcName?: string;
  dataHcEventName?: string;
  dataHcEventSection?: string;
  dataHcEventType?: string;
  handleSelect?: VoidFunction;
  multiselect?: boolean;
  nonInteractive?: boolean;
  highlightAlternating?: boolean;
  className?: string;
  theme?: {
    Option?: string;
    OptionSelected?: string;
  };
}

export const AutoCompleteOption = ({
  label,
  setRef,
  selected,
  highlighted,
  dataHcName,
  dataHcEventName,
  dataHcEventSection,
  dataHcEventType,
  handleSelect,
  multiselect,
  nonInteractive,
  highlightAlternating,
  className,
  theme,
}: Props) => {
  return (
    <div
      role="option"
      aria-selected={selected || highlighted}
      tabIndex={0}
      ref={(el) => setRef && setRef(el)}
      data-hc-name={dataHcName}
      data-hc-event-name={dataHcEventName}
      data-hc-event-section={dataHcEventSection}
      data-hc-event-type={dataHcEventType}
      onClick={handleSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && handleSelect) {
          handleSelect();
        }
      }}
      className={classNames(styles.Option, theme?.Option, className, {
        // Always apply default styles
        [styles.OptionLightHighlight || '']: selected,
        [styles.OptionDarkHighlight || '']:
          highlighted && !(selected && !multiselect),
        [styles.multiselect || '']: multiselect,
        // Apply theme classes when defined
        [theme?.OptionSelected || '']: !!theme?.OptionSelected && selected,
        [styles.nonInteractive || '']: nonInteractive,
        [styles.highlightAlternating || '']: highlightAlternating,
      })}
    >
      {multiselect && handleSelect && (
        <Checkbox
          dataHcName={`${dataHcName}-checkbox`}
          checked={selected}
          onChange={handleSelect}
          stopClickPropagation
        />
      )}
      <span className={styles.Label}>{label}</span>
    </div>
  );
};
